import { useState, useEffect } from 'react';

interface LibraryData {
  id: number;
  slug: string;
  title: string;
  thumbnail: string;
}

interface ApiResponse {
  success: boolean;
  data: LibraryData;
}

export const useLibraryData = (exhibitorSlug: string, librarySlug: string) => {
  const [data, setData] = useState<LibraryData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!exhibitorSlug || !librarySlug) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await fetch(
          `https://evort.com/jp/ja/api/${exhibitorSlug}/${librarySlug}`
        );
        
        if (!response.ok) {
          throw new Error(`Failed to fetch library data: ${response.statusText}`);
        }
        
        const result: ApiResponse = await response.json();
        
        if (!result.success) {
          throw new Error('API returned unsuccessful response');
        }
        
        setData(result.data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error occurred'));
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [exhibitorSlug, librarySlug]);

  return { data, loading, error };
};